import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { QcDashboardStore } from '../stores/qcDashboardStore';

export const useQcDashboardStore = () =>
  useContext<{
    qcDashboardStore: QcDashboardStore;
  }>(StoreContext);
